import React from 'react'
import emailjs from '@emailjs/browser'
import './Join.css'
import { useRef } from 'react'



const Join = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_hl37mgg', 'template_vhcnt67', form.current, 'XGpn8XNcYf_L9erVi')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };

  return (
    <div className="join" id="join-us">
        <div className="left-j">
            <div>
                <hr />
                <span className='stroke-text'>Ready to </span>
                <span>Lavel Up</span>
            </div>
            <div>
                <span>Your Body </span>
                <span className='stroke-text'>With Us?</span>
            </div>
        </div>
        <div className="right-j">
            <form ref={form} className="email-container" onSubmit={sendEmail}>
                <input type="email" name='user_email' placeholder='Enter Your Email Address'/>
                <button className='btn btn-j'>Join Now</button>
            </form>
        </div>
    </div>
  )
}

export default Join